/**
 * Bonsait Site API - Main entry point
 * 
 * This file is bundled by webpack into: public/js/api/bonsait-siteapi.js
 * 
 * Auto-initializes on page load:
 * - Analytics tracking (pageview + custom events)
 * - Form spam protection (HPI calculation)
 * 
 * Usage in HTML:
 * <script src="/public/js/api/bonsait-siteapi.js"></script>
 * 
 * No additional setup needed! Everything works automatically.
 * 
 * You can still manually call:
 * - Bonsait.Analytics.trackEvent('event_name', { data })
 * - Bonsait.Forms.getHumanScore()
 * - Bonsait.Utils.setCookie('name', 'value', 365)
 * 
 * Legacy API (still supported):
 * - Bonsait.collect('setup') - not needed, auto-runs
 * - Bonsait.forms('setup') - not needed, auto-runs
 * - Bonsait.collect('event', 'my_event')
 */

// Import all functionality from the refactored v2 API
import Bonsait from './Bonsait-v2';

// Import animation engine — self-executes to wire up data-attribute elements
import { Animations } from './bonsait-animations.js';
Bonsait.Animations = Animations;

// Export everything for webpack to bundle
// The webpack config exports this as global window.Bonsait
export default Bonsait;

// Also export individual functions for backward compatibility
export const {
    Analytics,
    Forms,
    Utils,
    collect,
    collectEvent,
    forms,
    getBrowser,
    isMobile,
    getDevice,
    setCookie,
    getCookie,
    getNumberValue,
    getParameterByName
} = Bonsait;
